import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()
  return {
    containerButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: 1,
      marginTop: 1,
      marginBottom: 1
    },
    cancelButton: {
      '&.MuiButton-root': {
        padding: '0px'
      }
    },
    containerFilter: {
      display: 'flex',
      gap: 2,
      position: 'relative',
    },
    clean: {
      fontSize: '2rem',
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    hide: {
      visibility: 'hidden',
    },
    drawerfilter: {
      height: '40px',
      width: '40px'
    },
    section: {
      marginBottom: '32px',
    },
    containerTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    title: { 
        fontSize:'16px',
        fontWeight: '500'
    }
  }
}

export { useStyles }
